import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { GqlProjectStatus } from "~/__generated__";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import { parseDateToString } from "~/modules/app/util/dateHelpers";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

import ProjectForm, { ProjectFormData } from "../../components/ProjectForm";
import useCreateProjectUrl from "../../hooks/useCreateProjectUrl";
import useProjectCreate from "./api/useProjectCreate";

const initialData: ProjectFormData = {
    name: "",
    contactEmail: "",
    contactName: "",
    contactPhone: "",
    status: GqlProjectStatus.Open,
    isSpeciesManagementPlan: false,
    showAllObservationsToClientUser: false,
    travelAllowanceKms: 200,
    travelAllowancePerKmInCents: 40,
    travelAllowanceTimeInSeconds: 60 * 60 * 2,
};

export default function ProjectCreateScreen() {
    const { t } = useTranslation("project");
    const { client } = useRequireCurrentClient();
    const createProjectUrl = useCreateProjectUrl();
    const navigate = useNavigate();

    const { projectCreate, error } = useProjectCreate(client);

    const handleSubmit = async (data: ProjectFormData) => {
        const result = await projectCreate({
            ...data,
            startAt: data.startAt ?? parseDateToString(new Date()),
        });
        if (result.data?.projectCreate) {
            navigate(createProjectUrl("", { project: result.data.projectCreate }));
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("projectCreateScreen.title")}>
                <ProjectForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    error={error}
                    formButtonLabel={t("projectCreateScreen.btnSubmit")}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
